var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75116 14.3728V27.8728C5.75116 29.9941 5.75116 31.0548 6.41017 31.7138C7.06918 32.3728 8.12984 32.3728 10.2512 32.3728H26.0012C28.1225 32.3728 29.1831 32.3728 29.8421 31.7138C30.5012 31.0548 30.5012 29.9941 30.5012 27.8728V14.3728",
    stroke: "#707070",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50171 16.6233L14.9447 5.18027C16.4447 3.68027 17.1947 2.93027 18.1267 2.93027C19.0587 2.93027 19.8087 3.68027 21.3087 5.18027L32.7517 16.6233",
    stroke: "#707070",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6267 26.7483C13.6267 24.627 13.6267 23.5663 14.2857 22.9073C14.9447 22.2483 16.0054 22.2483 18.1267 22.2483C20.248 22.2483 21.3087 22.2483 21.9677 22.9073C22.6267 23.5663 22.6267 24.627 22.6267 26.7483V33.4983H13.6267V26.7483Z",
    fill: "#707070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 6.4978C24.8789 5.43714 24.8789 4.90681 25.2084 4.57731C25.5379 4.2478 26.0682 4.2478 27.1289 4.2478C28.1896 4.2478 28.7199 4.2478 29.0494 4.57731C29.3789 4.90681 29.3789 5.43714 29.3789 6.4978V13.2478L26.1969 10.0658C25.5466 9.4155 25.2214 9.09034 25.0502 8.67686C24.8789 8.26338 24.8789 7.80353 24.8789 6.88384V6.4978Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b63b79bbfbe3f1ce39fb2cdf1468b7d3.svg";
export { ForwardRef as ReactComponent };